
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { FontMixin, Font } from '../../mixins/Font';

@Component
export default class Headline extends Mixins(FontMixin) {
  @Prop({ default: 'h3' }) element!: string;
  @Prop({ required: true }) text!: string;
  @Prop() textColor!: string;
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ default: Font.POPPINS }) font!: Font;

  get classNames() {
    return [
      { 'headline-c--dark': this.isDark },
    ];
  }

  get style() {
    return {
      fontFamily: this.$getFontFamily(this.font),
      color: this.textColor || undefined,
    };
  }
}
